/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo Servidores.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/servidores',
    name: 'servidores.index',
    component: () => import('./views/ServidoresIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'servidores.read',
      title: 'Servidores',
    },
  },
]

export default routes
